/**
 * Prepends a single item to a list, ensuring it appears only once.
 *
 * Useful for "pin the clicked/featured resource to the top of a paginated
 * feed" pages: even if the same resource is already inside `items` (e.g. the
 * SWR page-1 results), it will only show up once — at the top.
 *
 * Comparison is by JSON:API `id`. If `pinned` is null/undefined, the list is
 * returned unchanged so the page can still render gracefully on a bad response.
 */
export function prependUnique<T extends { id?: string }>(pinned: T | null | undefined, items: Array<T>): Array<T> {
	if (!pinned) {
		return items;
	}

	return [pinned, ...items.filter((item) => item?.id !== pinned.id)];
}
